import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ClosableTooltip from '@dc/ui-library/src/organisms/ClosableTooltip/ClosableTooltip';
import { hideFlexibleCreditTooltip } from '../../../../appState/ducks/listingPageProducts';
import uiLocale from '../../../../utils/UILocale.js';
import { createMarkup } from '../helpers';

class ProductFlexibleCreditTooltip extends React.PureComponent {
  constructor(props) {
    super(props);
    this.setFlexibleCreditTooltipRef = this.setFlexibleCreditTooltipRef.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    this.positionHandler = this.props.positionHandler.bind(this);

    this.state = {
      styleLeftPx: 0,
      styleTopPx: 0
    };
  }

  componentDidUpdate() {
    this.positionHandler();
  }

  onCloseButtonClick(e) {
    e.preventDefault();
    this.props.hideFlexibleCreditTooltip();
  }

  setFlexibleCreditTooltipRef(ref) {
    this.flexibleCreditTooltipRef = ref;
    if (!ref) {
      return;
    }

    this.positionHandler();
  }

  render() {
    const styles = {
      left: `${this.state.styleLeftPx}px`,
      top: `${this.state.styleTopPx}px`
    };
    
    if (this.props.styleWidthPx) {
      styles.width = `${this.props.styleWidthPx}px`;
    }

    return ReactDOM.createPortal((
      <div
        ref={this.setFlexibleCreditTooltipRef}
        className="dc-tooltip-onlineCredit"
        style={styles}
      >
        <ClosableTooltip
          arrow={this.props.arrowDirection}
          closeOnClickOutsideEnabled
          display
          onCloseButtonClick={this.onCloseButtonClick}
          onClickOutsideOfTooltip={this.props.hideFlexibleCreditTooltip}
          closeTooltipLabel="Got it"
          closeButtonAlign="bottom"
          hideCross
          id={this.props.productID}
          parentWrapperRef={this.props.flexibleCreditAnchorRef}
        >
          <h4
            dangerouslySetInnerHTML={
              createMarkup(uiLocale.getString('component.onlinecredit.product-callout-header'))
            }
          />
          <div
            dangerouslySetInnerHTML={
              createMarkup(uiLocale.getString('component.onlinecredit.product-callout-text'))
            }
          />
        </ClosableTooltip>
      </div>),
    document.body);
  }
}

ProductFlexibleCreditTooltip.displayName = 'ProductFlexibleCreditTooltip';

ProductFlexibleCreditTooltip.propTypes = {
  productID: PropTypes.string.isRequired,
  flexibleCreditAnchorRef: PropTypes.instanceOf(Element).isRequired,
  arrowDirection: PropTypes.string,
  hideFlexibleCreditTooltip: PropTypes.func,
  styleWidthPx: PropTypes.number,
  viewportWidth: PropTypes.number.isRequired,
  positionHandler: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired
};

ProductFlexibleCreditTooltip.defaultProps = {
  hideFlexibleCreditTooltip: () => {},
  arrowDirection: 'right',
  styleWidthPx: 0
};

function mapStateToProps(state) {
  return {
    deviceType: state.general.device.deviceType,
    viewportWidth: state.general.viewportWidth
  };
}

export function gridViewPositionHandler() {
  const anchorLeft = this.props.flexibleCreditAnchorRef.getBoundingClientRect().left;
  const anchorTop = this.props.flexibleCreditAnchorRef.getBoundingClientRect().top;
  const tooltipWidth = this.flexibleCreditTooltipRef.getBoundingClientRect().width;
  const tooltipHeight = this.flexibleCreditTooltipRef.getBoundingClientRect().height;

  if (this.props.deviceType === 'desktop' || this.props.deviceType === 'wide') {
    this.setState({
      styleLeftPx: anchorLeft - tooltipWidth - 10,
      styleTopPx: (anchorTop + window.pageYOffset + 10) - (tooltipHeight / 2)
    });
  } else if (this.props.deviceType === 'tablet') {
    this.setState({
      styleTopPx: ((anchorTop + window.pageYOffset) - tooltipHeight - 16),
      styleLeftPx: anchorLeft
    });
  }
}

export function listViewPositionHandler() {
  const anchorLeft = this.props.flexibleCreditAnchorRef.getBoundingClientRect().left;
  const anchorTop = this.props.flexibleCreditAnchorRef.getBoundingClientRect().top;
  const tooltipWidth = this.flexibleCreditTooltipRef.getBoundingClientRect().width;
  const tooltipHeight = this.flexibleCreditTooltipRef.getBoundingClientRect().height;

  this.setState({
    styleLeftPx: anchorLeft - tooltipWidth,
    styleTopPx: (anchorTop + window.pageYOffset + 10) - (tooltipHeight / 2)
  });
}

const dispatchFunctions = {
  hideFlexibleCreditTooltip
};

export default connect(mapStateToProps, dispatchFunctions)(ProductFlexibleCreditTooltip);
